<template>
    <div class="artic-item" @click="toDetail()">
        <div class="artic-item__content">
            <div class="artic-item__info">
                <div class="artic-item__title-container">
                    <span v-if="areaName" class="area-tag">{{ areaName }}</span>
                    <p class="artic-item__title ellipsis" v-html="highlight.title || item.articleInfo.title"></p>
                </div>
                <p v-if="hasDesc" class="artic-item__desc"
                   v-html="highlight.description || highlight.text || item.articleInfo.descContent"></p>
            </div>
            <div v-if="item.articleInfo.coverImage" class="artic-item__cover-container">
                <img :src="item.articleInfo.coverImage" alt="文章封面" class="artic-item__cover" />
            </div>
        </div>
        <ul class="artic-item__meta__action">
            <li class="meta-item">
                <span class="meta-item__username">
                    <router-link :to="'/community/user/'+uid" target="_blank"
                                 @click.native="(e) => e.stopPropagation()">{{ item.userInfo.nickName || item.userInfo.userNumber}}</router-link>
                </span>
            </li>
            <li class="meta-item">{{ item.articleInfo.createTime }}</li>
            <li class="action-item" :class="{active: item.articleInfo[likeField]}" @click.stop="articleLike">
                <img src="@/assets/images/like-active.svg" class="action-item__icon" v-if="item.articleInfo.likeStatus === '1'" />
                <img src="@/assets/images/like.svg" class="action-item__icon"  v-else />
                {{ item.articleInfo[likeCount] }}
            </li>
            <li class="action-item" @click.stop="toDetail('#comment')">
                <img class="action-item__icon" src="@/assets/images/comment.svg">
                {{ item.articleInfo.commentCount }}
            </li>
            <li class="meta-item">
                <template v-if="item.tags.length">
                    <span class="meta-item__tag" v-for="tag in item.tags"
                                 :key="tag.id"  @click.stop="(e) => e.stopPropagation()">
                        {{ tag.name }}
                    </span>
                </template>
            </li>
        </ul>
    </div>
</template>

<script>
import {doAction} from '@/api'
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        hasDesc: {
            type: Boolean,
            default: true,
        },
        highlight: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        // 点赞状态字段不一致  此处筛选出对应字段
        likeField() {
            let fields = ['likeStatus']
            return fields.filter(key => this.item.articleInfo[key] === undefined ? false : key)[0]
        },
        // 点赞数字段不一致  此处筛选出对应字段
        likeCount() {
            let fields = ['likeCount']
            return fields.filter(key => this.item.articleInfo[key] === undefined ? false : key)[0]
        },
        // 统一 uid值
        uid() {
            return this.item.userInfo.userId
        },
        detailId() {
            return this.item.articleId
        },
        areaName() {
            // 如果文章有区域ID，则从store中获取对应的区域名称
            if (this.item.articleInfo && this.item.articleInfo.areaId) {
                const areaList = this.$store.getters["category/getState"].areaCategoryList || [];
                const area = areaList.find(area => area.areaId === this.item.articleInfo.areaId);
                return area ? area.content : '';
            }
            return '';
        }
    },
    methods: {
        toDetail(hash = '') {
            let routeUrl = this.$router.resolve({
                name: 'detail-id',
                params: {
                    id: this.detailId
                }
            })
            window.open(routeUrl.href + hash, '_blank')
        },
        async articleLike() {
            if (!this.$store.state.user.token) {
                this.$router.push("/login/account");
                return
            }

            let id = this.item.articleId;
            // 点赞行为
            if(this.item.articleInfo.likeStatus === '0') {
                this.item.articleInfo.likeStatus = '1';
            } else if(this.item.articleInfo.likeStatus === '1') { // 取消点赞行为
                this.item.articleInfo.likeStatus = '0';
            }
            if (id && this.likeField && this.likeCount) { 
                doAction({
                actionType: 1,
                targetId: id,
                targetType: 6,
                status: this.item.articleInfo.likeStatus
                }).then(res=> {
                    this.item.articleInfo.likeStatus === '1' ? this.item.articleInfo.likeCount+=1 : this.item.articleInfo.likeCount-=1
                    if(this.item.articleInfo.likeStatus === '1') {
                        this.$message.success('点赞成功');
                    } else {
                        this.$message.success('取消点赞成功');
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.artic-item {
    display: flex;
    flex-direction: column;
    padding: 8px 20px;
    cursor: pointer;
    height: 120px;
    box-sizing: border-box;

    &:hover {
        background: rgba(0, 0, 0, .01);
    }
}

.artic-item__content {
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;
    height: 80px;
}

.artic-item__info {
    flex: 1 1 auto;
    overflow: hidden;
    padding-right: 20px;
}

.artic-item__cover-container {
    flex: 0 0 auto;
    width: 120px;
    height: 80px;
    border-radius: 2px;
    overflow: hidden;
    position: relative;
}

.artic-item__cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
}

.artic-item__meta__action {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    font-size: $font-size-Level7;
    color: $font-color-fourth;
    margin-top: auto;

    .meta-item {
        &:last-child {
            margin-left: auto;
            display: flex;
            flex-wrap: wrap;
            gap: 4px;
            justify-content: flex-end;
        }
    }

    .meta-item__username {
        cursor: pointer;

        & > a:hover {
            color: $color-primary !important;
        }

        &::after {
            margin: 0 6px;
            content: " | ";
            color: #b2bac2;
        }
    }

    .meta-item__tag {
        // cursor: pointer;
        background-color: #F7F8FA;
        color: #999;
        margin-right: 8px;
        margin-bottom: 1px;
        padding: 0 8px;
        border-radius: 5px;
        display: inline-block;
        white-space: nowrap;
        line-height: 22px;
        height: 22px;

        &:last-child {
            margin-right: 0;
        }
    }

    .action-item {
        display: flex;
        align-items: center;
        height: 22px;
        padding: 0 8px;
        img {
            width: 14px;
        }

        .action-item__icon {
            margin-right: 2px;
            display: block;
            width: 14px;
            height: 14px;
        }

        &:last-child {
            border-left: 0;
        }
    }
}

.artic-item__title-container {
    display: flex;
    align-items: center;
    margin: 5px 0 8px;
    
    .area-tag {
        flex-shrink: 0;
        font-size: $font-size-Level7;
        background-color: rgba($color-primary, 0.08);
        color: $color-primary;
        padding: 0 5px;
        border-radius: 2px;
        margin-right: 8px;
        line-height: 18px;
        height: 18px;
        display: inline-block;
        border: 1px solid rgba($color-primary, 0.2);
        font-weight: normal;
    }
}

.artic-item__title {
    display: block;
    line-height: 1.2;
    font-size: $font-size-Level5;
    font-weight: 700;
    color: inherit;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
        text-decoration: underline;
    }

    ::v-deep em {
        color: #e8001c;
    }
}

.artic-item__desc {
    margin-bottom: 8px;
    font-size: $font-size-primary;
    color: #5b6169;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.4;
    max-height: 20px;
    :deep(img) {
        display: none !important;
    }
}

</style>
